import React from "react";
import { SocialIcon } from "react-social-icons";
import "./TeamMember.css";

function TeamMember(props: {
  src: string;
  name: string;
  mail?: string;
  description: string;
  team: string;
  role: string;
  oneline: string;
  linkedin?: string;
  urls?: string[];
  isOpen: boolean;
  onClick: () => void;
}) {
  const colors = ["bg-RougePastel", "bg-ThemeGray"];

  let elt = Math.floor(Math.random() * colors.length);
  console.log(elt);
  console.log(props.name, colors[elt]);

  const iconSize = { height: 35, width: 35 };
  return (
    <div className="group h-96 w-80 [perspective:1000px]">
      <div className="relative h-full w-full rounded-xl shadow-xl transition-all duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
        <div className="absolute inset-0">
          <img
            className="object-cover w-full h-full rounded-xl shadow-xl shadow-black/40"
            src={props.src}
            alt=""
          />

          <div className="flex absolute right-0 bottom-0 left-0 flex-col justify-center items-center p-4 text-center text-white bg-gradient-to-t to-transparent frome-black">
            <span className="text-lg font-medium font-Roboto">
              {props.name}
            </span>
            <span className="text-sm opacity-70 font-regular font-Roboto">
              {props.role}
            </span>
          </div>
        </div>
        <div
          className={`absolute inset-0 px-12 w-full h-full text-center rounded-xl ${
            colors[Math.floor(Math.random() * colors.length)]
          } text-slate-200 [transform:rotateY(180deg)] [backface-visibility:hidden] opacity-90`}
        >
          <div className="flex flex-col justify-around min-h-full text-left">
            <h1 className="pb-2 font-bold text-center text-md">Description</h1>
            <p className="text-[12px] text-justify font-bold">
              {props.description}
            </p>
            <div className="flex justify-around w-full">
              {props.linkedin ? (
                <SocialIcon url={props.linkedin} style={iconSize} />
              ) : (
                ""
              )}
              {props.urls?.map((elt, idx) => {
                return <SocialIcon url={elt} key={idx} style={iconSize} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamMember;
